<template>
  <v-dialog
    :model-value="confirmationDialog.dialogVisible.value"
    max-width="500"
    persistent
    transition="slide-y-transition">
    <v-card>
      <v-toolbar :color="toolbarColor" density="compact">
        <v-icon size="small" icon="mdi-comment-question" class="ml-4"></v-icon>
        <v-toolbar-title>{{ confirmationDialog.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn size="small" icon="mdi-close" @click="confirmationDialog.cancel"></v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="pb-2">{{ confirmationDialog.message }}</div>
        <template v-if="confirmationDialog.warnings.value.length > 0">
          <p class="warning-label"><strong>Warning Fields:</strong></p>
          <table class="warning-fields-table">
            <tr v-for="field in confirmationDialog.warnings.value">
              <td>{{ field.label }}</td>
              <td>{{ field.warning }}</td>
            </tr>
          </table>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="elevated" color="warning" @click="confirmationDialog.confirm">{{
          confirmationDialog.confirmLabel
        }}</v-btn>
        <v-btn variant="elevated" color="info" @click="confirmationDialog.cancel">{{
          confirmationDialog.cancelLabel
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useConfirmationDialog } from "./use_confirmation_dialog";

const confirmationDialog = useConfirmationDialog();

const toolbarColor = computed(() => {
  if (confirmationDialog.warnings.value.length > 0) {
    return "warning";
  }
  return "#78909c"; // Default color
});
</script>
<style scoped lang="scss">
.warning-label {
  font-size: 14px;
}

.warning-fields-table {
  width: 100%;
  border-collapse: collapse;

  tr {
    border: 1px solid #ccc;
  }

  td {
    padding: 2px 8px;
    font-size: 13px;
  }
}
</style>
